<template>
  <div>
    <div class="defaultBox">
      <div class="left">
        <div class="title">{{ nickname }}</div>
        <div class="profilePhoto">
          <img :src="profilePhoto" alt="" />
        </div>
        <div class="item">
          <div class="subTitle">开始答题时间</div>
          <div class="text">{{ new Date(addTime).toLocaleString() }}</div>
        </div>
        <div class="item">
          <div class="subTitle">答题结束时间</div>
          <div class="text">{{ new Date(endTime).toLocaleString() }}</div>
        </div>
        <div class="item">
          <div class="subTitle">答题时长</div>
          <div class="text">{{ useTimeText }}</div>
        </div>
      </div>
      <div v-if="questionnaireType == 1" class="right">
        <div v-for="(item, index) in dataList" :key="index" @click.stop="">
          <div class="item" v-if="item.type == QuestionType.SCQ">
            <QuestionPreviewSCQ
              :params="{ data: item, index: index }"
            ></QuestionPreviewSCQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.MCQ">
            <QuestionPreviewMCQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewMCQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.SBQ">
            <QuestionPreviewSBQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewSBQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.MBQ">
            <QuestionPreviewMBQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewMBQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.DLQ">
            <QuestionPreviewDLQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewDLQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.NPS">
            <QuestionPreviewNPS
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewNPS>
          </div>
          <div class="item" v-if="item.type == QuestionType.VOTE">
            <QuestionPreviewVote
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewVote>
          </div>
          <div class="item" v-if="item.type == QuestionType.SORT">
            <QuestionPreviewSort
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewSort>
          </div>
          <div class="item" v-if="item.type == QuestionType.REMARK">
            <QuestionPreviewRemark
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewRemark>
          </div>
          <div class="item" v-if="item.type == QuestionType.SCORE">
            <QuestionPreviewScore
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewScore>
          </div>
          <div class="item" v-if="item.type == QuestionType.QA">
            <QuestionPreviewQA
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewQA>
          </div>
          <div class="item" v-if="item.type == QuestionType.WRQ">
            <QuestionPreviewWRQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewWRQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.SRQ">
            <QuestionPreviewSRQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewSRQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.IMAGE">
            <QuestionPreviewImage
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewImage>
          </div>
          <div
            class="item"
            v-if="item.type == QuestionType.MaxDiff"
            :class="{ 'max-diff': item.type === QuestionType.MaxDiff }"
          >
            <QuestionPreviewMaxDiff
              :params="{
                data: defaultDataSubject[index],
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewMaxDiff>
          </div>
          <div class="item" v-if="item.type == QuestionType.UploadFile">
            <QuestionPreviewUploadFile
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewUploadFile>
          </div>
          <div class="item" v-if="item.type == QuestionType.DownloadFile">
            <QuestionPreviewDownloadFile
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            >
            </QuestionPreviewDownloadFile>
          </div>
          <div class="item" v-if="item.type == QuestionType.CASCADER">
            <QuestionPreviewCASCADER
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewCASCADER>
          </div>
          <div class="item" v-if="item.type == QuestionType.MatrixSCQ">
            <QuestionPreviewMatrixScq
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewMatrixScq>
          </div>
          <div class="item" v-if="item.type == QuestionType.MatrixMCQ">
            <QuestionPreviewMatrixMcq
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewMatrixMcq>
          </div>
          <div class="item" v-if="item.type == QuestionType.ImageSCQ">
            <QuestionPreviewImageScq
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewImageScq>
          </div>
          <div class="item" v-if="item.type == QuestionType.ImageMCQ">
            <QuestionPreviewImageMcq
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewImageMcq>
          </div>
          <div class="item" v-if="item.type == QuestionType.ImageOrVideo">
            <QuestionPreviewImageOrVideo
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewImageOrVideo>
          </div>
          <div class="item" v-if="item.type == QuestionType.Signature">
            <QuestionPreviewSignature
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewSignature>
          </div>
          <div class="item" v-if="item.type == QuestionType.NAME">
            <QuestionPreviewName
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewName>
          </div>
          <div class="item" v-if="item.type == QuestionType.GENDER">
            <QuestionPreviewGender
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewGender>
          </div>
          <div class="item" v-if="item.type == QuestionType.AGE">
            <QuestionPreviewAge
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewAge>
          </div>
          <div class="item" v-if="item.type == QuestionType.TEL">
            <QuestionPreviewTel
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewTel>
          </div>
          <div class="item" v-if="item.type == QuestionType.EMAIL">
            <QuestionPreviewEmail
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewEmail>
          </div>
          <div class="item" v-if="item.type == QuestionType.DATE">
            <QuestionPreviewDate
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewDate>
          </div>
          <div class="item" v-if="item.type == QuestionType.TIME">
            <QuestionPreviewTime
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewTime>
          </div>
          <div class="item" v-if="item.type == QuestionType.ADDR">
            <QuestionPreviewAddress
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewAddress>
          </div>
          <div class="item" v-if="item.type == QuestionType.BDQ">
            <QuestionPreviewBDQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewBDQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.IDQ">
            <QuestionPreviewIDQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewIDQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.ELQ">
            <QuestionPreviewELQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewELQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.WX">
            <QuestionPreviewWX
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewWX>
          </div>
          <div class="item" v-if="item.type == QuestionType.Customize">
            <QuestionPreviewCustomize
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewCustomize>
          </div>
        </div>
      </div>
      <div v-if="questionnaireType == 2" class="right">
        <div v-for="(item, index) in dataList" :key="index" @click.stop="">
          <div class="item" v-if="item.type == QuestionType.SCQ">
            <ExamPreviewSCQ
              :params="{ data: item, index: index }"
              :showAnswer="true"
            ></ExamPreviewSCQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.MCQ">
            <ExamPreviewMCQ
              :params="{ data: item, index: index }"
              :showAnswer="true"
            ></ExamPreviewMCQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.TFQ">
            <ExamPreviewTFQ
              :params="{ data: item, index: index }"
              :showAnswer="true"
            ></ExamPreviewTFQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.SBQ">
            <ExamPreviewSBQ
              :params="{ data: item, index: index }"
              :showAnswer="true"
            ></ExamPreviewSBQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.MBQ">
            <ExamPreviewMBQ
              :params="{ data: item, index: index }"
              :showAnswer="true"
            ></ExamPreviewMBQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.QA">
            <ExamPreviewQA
              :params="{ data: item, index: index }"
              :showAnswer="true"
            ></ExamPreviewQA>
          </div>
          <div class="item" v-if="item.type == QuestionType.IMAGE">
            <ExamPreviewIMAGE
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></ExamPreviewIMAGE>
          </div>
          <div class="item" v-if="item.type == QuestionType.ClozeTest">
            <ExamPreviewClozeTest
              :params="{ data: item, index: index }"
              :showAnswer="true"
            ></ExamPreviewClozeTest>
          </div>
          <div class="item" v-if="item.type == QuestionType.REMARK">
            <ExamPreviewRemark
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></ExamPreviewRemark>
          </div>
          <div class="item" v-if="item.type == QuestionType.NAME">
            <QuestionPreviewName
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewName>
          </div>
          <div class="item" v-if="item.type == QuestionType.GENDER">
            <QuestionPreviewGender
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewGender>
          </div>
          <div class="item" v-if="item.type == QuestionType.AGE">
            <QuestionPreviewAge
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewAge>
          </div>
          <div class="item" v-if="item.type == QuestionType.TEL">
            <QuestionPreviewTel
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewTel>
          </div>
          <div class="item" v-if="item.type == QuestionType.EMAIL">
            <QuestionPreviewEmail
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewEmail>
          </div>
          <div class="item" v-if="item.type == QuestionType.DATE">
            <QuestionPreviewDate
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewDate>
          </div>
          <div class="item" v-if="item.type == QuestionType.TIME">
            <QuestionPreviewTime
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewTime>
          </div>
          <div class="item" v-if="item.type == QuestionType.ADDR">
            <QuestionPreviewAddress
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewAddress>
          </div>
          <div class="item" v-if="item.type == QuestionType.BDQ">
            <QuestionPreviewBDQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewBDQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.IDQ">
            <QuestionPreviewIDQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewIDQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.ELQ">
            <QuestionPreviewELQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewELQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.WX">
            <QuestionPreviewWX
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewWX>
          </div>
          <div class="item" v-if="item.type == QuestionType.Customize">
            <QuestionPreviewCustomize
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewCustomize>
          </div>
        </div>
      </div>
      <div v-if="questionnaireType == 3" class="right">
        <div v-for="(item, index) in dataList" :key="index" @click.stop="">
          <div class="item" v-if="item.type == QuestionType.EvaluationSCQ">
            <EvaluationPreviewSCQ
              :params="{ data: item, index: index }"
              :showAnswer="true"
            ></EvaluationPreviewSCQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.EvaluationMCQ">
            <EvaluationPreviewMCQ
              :params="{ data: item, index: index }"
              :showAnswer="true"
            ></EvaluationPreviewMCQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.EvaluationWRQ">
            <EvaluationPreviewWRQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewWRQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.EvaluationNPS">
            <EvaluationPreviewNPS
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewNPS>
          </div>
          <div class="item" v-if="item.type == QuestionType.EvaluationScore">
            <EvaluationPreviewScore
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewScore>
          </div>
          <div class="item" v-if="item.type == QuestionType.TextDescription">
            <EvaluationPreviewDesc
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewDesc>
          </div>
          <div class="item" v-if="item.type == QuestionType.NAME">
            <EvaluationPreviewName
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewName>
          </div>
          <div class="item" v-if="item.type == QuestionType.GENDER">
            <EvaluationPreviewGender
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewGender>
          </div>
          <div class="item" v-if="item.type == QuestionType.AGE">
            <EvaluationPreviewAge
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewAge>
          </div>
          <div class="item" v-if="item.type == QuestionType.ELQ">
            <EvaluationPreviewELQ
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewELQ>
          </div>
          <div class="item" v-if="item.type == QuestionType.DATE">
            <EvaluationPreviewDate
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewDate>
          </div>
          <div class="item" v-if="item.type == QuestionType.ADDR">
            <EvaluationPreviewAddress
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewAddress>
          </div>
          <div
            class="item"
            v-if="item.type == QuestionType.EvaluationMatrixSCQ"
          >
            <EvaluationPreviewMatrixScq
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewMatrixScq>
          </div>
          <div class="item" v-if="item.type == QuestionType.ImageOrVideo">
            <EvaluationPreviewImageOrVideo
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewImageOrVideo>
          </div>
          <div class="item" v-if="item.type == QuestionType.Audio">
            <EvaluationPreviewAudio
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewAudio>
          </div>
          <div class="item" v-if="item.type == QuestionType.Industry">
            <EvaluationPreviewIndustry
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewIndustry>
          </div>
          <div class="item" v-if="item.type == QuestionType.Occupation">
            <EvaluationPreviewOccupation
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></EvaluationPreviewOccupation>
          </div>
          <div class="item" v-if="item.type == QuestionType.Customize">
            <QuestionPreviewCustomize
              :params="{
                data: item,
                answer: defaultDataAnswer[index],
                index: index,
              }"
            ></QuestionPreviewCustomize>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  questionnaireDetail,
  examinationDetail,
  assessmentDetail,
} from "@/api/index.js";
import { QuestionType } from "@/components/constant.js";
import { PreviewComponents } from "@/utils/componentImports.js";

export default {
  components: {
    ...PreviewComponents,
  },
  data() {
    return {
      id: null,
      uuid: null,
      nickname: null,
      addTime: null,
      endTime: null,
      profilePhoto: null,
      useTimeText: null,
      questionnaireType: null,
      QuestionType: this.$store.getters["questionType/getQuestionType"],
      defaultDataSubject: [],
      defaultDataAnswer: [],
      dataList: [],
      question_state: null,
      hasBreakPage: null,
      isPage: null,
    };
  },
  created() {},
  mounted() {
    this.id = this.$route.query.id;
    this.uuid = this.$route.query.uuid;
    this.nickname = this.$route.query.nickname;
    this.addTime = Number(this.$route.query.addTime);
    this.endTime = Number(this.$route.query.endTime);
    this.profilePhoto = this.$route.query.profilePhoto;
    this.questionnaireType = this.$route.query.questionnaireType;

    const durationMs = this.endTime - this.addTime;
    const seconds = Math.floor(durationMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const remainSeconds = seconds % 60;

    this.useTimeText = `${minutes}分${remainSeconds}秒`;

    this.postData();
  },
  methods: {
    postData() {
      if (this.questionnaireType == 1) {
        questionnaireDetail({
          answerRecordId: this.id,
          uuid: this.uuid,
        })
          .then((res) => {
            if (res.code === 200) {
              this.defaultDataSubject = res.data.questionList;
              // this.defaultDataAnswer = res.data.answerRecord;
              const answerMap = JSON.parse(res.data.answerRecord || "{}");
              this.defaultDataAnswer = answerMap;

              console.log("this.defaultDataSubject", this.defaultDataSubject);

              this.dataList = res.data.questionList.map((item) => {
                return {
                  ...item,
                  if_hide: 0,
                  status: this.status,
                };
              });
              this.dataList = this.dataList.map((item) => {
                if (item.type === this.QuestionType.SRQ) {
                  item.chooseList = JSON.stringify({
                    list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                      return {
                        ...temp,
                        context: item.scoreNum,
                      };
                    }),
                  });
                }
                return item;
              });

              const array = res.data.questionList;
              const answers =
                res.data.answerRecord !== null
                  ? JSON.parse(res.data.answerRecord)
                  : [];

              console.log("后台返回的答案在这里：", answers);

              this.answerQuestionDisplay(array, answers);
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }

      if (this.questionnaireType == 2) {
        examinationDetail({
          answerRecordId: this.id,
          uuid: this.uuid,
        })
          .then((res) => {
            if (res.code === 200) {
              this.defaultDataSubject = res.data.questionList;
              // this.defaultDataAnswer = res.data.answerRecord;
              const answerMap = JSON.parse(res.data.answerRecord || "{}");
              this.defaultDataAnswer = answerMap;

              console.log("this.defaultDataSubject", this.defaultDataSubject);

              this.dataList = res.data.questionList.map((item) => {
                return {
                  ...item,
                  if_hide: 0,
                  status: this.status,
                };
              });
              this.dataList = this.dataList.map((item) => {
                if (item.type === this.QuestionType.SRQ) {
                  item.chooseList = JSON.stringify({
                    list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                      return {
                        ...temp,
                        context: item.scoreNum,
                      };
                    }),
                  });
                }
                return item;
              });

              const array = res.data.questionList;
              const answers =
                res.data.answerRecord !== null
                  ? JSON.parse(res.data.answerRecord)
                  : [];

              console.log("后台返回的答案在这里：", answers);

              this.answerExamDisplay(array, answers);
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }

      if (this.questionnaireType == 3) {
        assessmentDetail({
          answerRecordId: this.id,
          uuid: this.uuid,
        })
          .then((res) => {
            if (res.code === 200) {
              this.defaultDataSubject = res.data.questionList;
              // this.defaultDataAnswer = res.data.answerRecord;
              const answerMap = JSON.parse(res.data.answerRecord || "{}");
              this.defaultDataAnswer = answerMap;

              console.log("this.defaultDataSubject", this.defaultDataSubject);

              this.dataList = res.data.questionList.map((item) => {
                return {
                  ...item,
                  if_hide: 0,
                  status: this.status,
                };
              });
              this.dataList = this.dataList.map((item) => {
                if (item.type === this.QuestionType.SRQ) {
                  item.chooseList = JSON.stringify({
                    list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                      return {
                        ...temp,
                        context: item.scoreNum,
                      };
                    }),
                  });
                }
                return item;
              });

              const array = res.data.questionList;
              const answers =
                res.data.answerRecord !== null
                  ? JSON.parse(res.data.answerRecord)
                  : [];

              console.log("后台返回的答案在这里：", answers);

              this.answerEvaluationDisplay(array, answers);
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    },
    answerQuestionDisplay(array, answers) {
      console.log("这个是问题列表：", array);
      console.log("这个是后台返回的答案：", answers);
      this.answers = [];
      // 初始化answers,构建出每道题目的答案数据
      for (let i = 0; i < array.length; i++) {
        if (answers[i] !== null && answers[i] !== undefined) {
          answers[i].if_hide = 0;
          this.answers.push(answers[i]);
        } else {
          if (array[i].type === this.QuestionType.MCQ) {
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: [],
            });
          } else if (array[i].type === this.QuestionType.SBQ) {
            const num = array[i].caseProblem.split("____").length - 1;
            // 构建答案数据
            let answer = [];
            for (let j = 0; j < num; j++) {
              answer.push({
                id: "",
                context: "",
              });
            }
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: answer,
            });
          } else if (array[i].type === this.QuestionType.IMAGE) {
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: [],
            });
          } else if (
            array[i].type === this.QuestionType.MatrixSCQ ||
            array[i].type === this.QuestionType.MatrixMCQ
          ) {
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: JSON.parse(array[i].chooseList).list.map((item) => {
                return {
                  id: item.id,
                  oneId: "",
                  twoId: "",
                  threeId: "",
                };
              }),
            });
          } else {
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: [],
            });
          }
        }
      }
      console.log("这个是构建的数据答案：", this.answers);
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const answerItem =
          this.answers.find(
            (a) => parseInt(a.question_id) === parseInt(item.id),
          ) === undefined
            ? {
                question_id: item.id,
                type: array[i].type,
                if_hide: 0,
                answer: [],
              }
            : this.answers.find(
                (a) => parseInt(a.question_id) === parseInt(item.id),
              );
        // console.log("这是answer", answerItem, i);
        switch (item.type) {
          case this.QuestionType.SCQ:
            console.log("这是SCQ", item, answerItem);
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    isChoose:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                        : false,
                    placeholder: temp.fill_prompt,
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                          ? answerItem.answer[0].context
                          : ""
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.MCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  const matched = answerItem.answer.find(
                    (a) => parseInt(a.id) === parseInt(temp.id),
                  );
                  return {
                    ...temp,
                    placeholder: temp.fill_prompt,
                    isChoose: !!matched,
                    fill_prompt:
                      matched && matched.context ? matched.context : "",
                  };
                }),
                minCount: JSON.parse(item.chooseList).minCount,
                maxCount: JSON.parse(item.chooseList).maxCount,
                isCountMust: JSON.parse(item.chooseList).isCountMust,
                isCountSwitch: JSON.parse(item.chooseList).isCountSwitch,
              }),
            };
            break;
          case this.QuestionType.SBQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              answer: answerItem.answer.map((temp) => {
                return {
                  id: temp.id,
                  context: temp.context,
                };
              }),
            };
            break;
          case this.QuestionType.SRQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    scoreNum:
                      answerItem.answer.length > 0
                        ? answerItem.answer[idx].context
                        : 1,
                    context:
                      answerItem.answer.length > 0
                        ? answerItem.answer[idx].context
                        : 0,
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.DLQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                  };
                }),
                value:
                  answerItem.answer.length > 0
                    ? answerItem.answer[0].context
                    : "",
              }),
            };
            break;
          case this.QuestionType.NPS:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? parseInt(answerItem.answer[0].context)
                  : -1,
            };
            break;
          case this.QuestionType.VOTE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              if_answer: answerItem.answer.length > 0,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  const matched = answerItem.answer.find(
                    (a) => parseInt(a.id) === parseInt(temp.id),
                  );
                  console.log(matched, "e121r1r12jhr12fr12rg21gr12r21ur21uir1");
                  return {
                    ...temp,
                    placeholder: temp.fill_prompt,
                    isChoose:
                      matched && matched.select ? matched.select === 1 : false,
                    fill_prompt:
                      matched && matched.context ? matched.context : "",
                    count: matched && matched.count ? matched.count : 0,
                    percentage:
                      matched && matched.percentage ? matched.percentage : 0,
                  };
                }),
                minCount: JSON.parse(item.chooseList).minCount,
                maxCount: JSON.parse(item.chooseList).maxCount,
                isCountMust: JSON.parse(item.chooseList).isCountMust,
                isCountSwitch: JSON.parse(item.chooseList).isCountSwitch,
              }),
            };
            break;
          case this.QuestionType.SORT:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, index) => {
                  return {
                    ...temp,
                    number:
                      answerItem.answer.length > 0
                        ? answerItem.answer[index].context
                        : "",
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.REMARK:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
            };
            break;
          case this.QuestionType.SCORE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, index) => {
                  return {
                    ...temp,
                    context:
                      answerItem.answer.length > 0
                        ? answerItem.answer[index].context
                        : 0,
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.MBQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    context:
                      answerItem.answer.length > 0
                        ? answerItem.answer[idx].context
                        : "",
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.QA:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.NAME:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.GENDER:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                    isChoose:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                        : false,
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? answerItem.answer[0].context
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.AGE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                    isChoose:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                        : false,
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? answerItem.answer[0].context
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.TEL:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.EMAIL:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.DATE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.TIME:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.ADDR:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.WRQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  const matchedAnswer = (answerItem.answer || []).find(
                    (ans) => ans.id === temp.id,
                  );
                  return {
                    ...temp,
                    value: matchedAnswer ? matchedAnswer.context : "",
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.IMAGE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: answerItem.answer.length > 0 ? answerItem.answer : [],
              }),
            };
            break;
          case this.QuestionType.MaxDiff:
            let parsedChoose = {};
            try {
              parsedChoose = JSON.parse(item.chooseList || "{}");
            } catch (e) {
              console.warn("chooseList parse error", e);
            }

            const list = (parsedChoose.list || []).map((temp) => ({
              id: temp.id || "",
              context: temp.context || temp.text || temp.name || "",
            }));

            const maxDiffList = (parsedChoose.maxDiffList || []).map(
              (group, pageIndex) => ({
                list: (group.list || []).map((temp) => {
                  const ans =
                    (answerItem.answer || []).find(
                      (a) => a.taskIndex === pageIndex + 1,
                    ) || {};
                  const leftId = String(ans.leftId || "");
                  const rightId = String(ans.rightId || "");
                  const tempId = String(temp.id || "");

                  return {
                    id: tempId,
                    context: temp.context || temp.text || temp.name || "",
                    choice:
                      leftId === tempId
                        ? "best"
                        : rightId === tempId
                        ? "worst"
                        : "",
                  };
                }),
              }),
            );

            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: {
                attributesNum: parsedChoose.attributesNum || 0,
                tasksNum: parsedChoose.tasksNum || 1,
                percentageTitle:
                  parsedChoose.percentageTitle ||
                  `${answerItem.headerBest || "满意"},${
                    answerItem.headerWorst || "不满意"
                  }`,
                list,
                maxDiffList,
              },
            };
            break;
          case this.QuestionType.UploadFile:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: (answerItem.answer || []).map((a) => ({
                  url: a.context,
                  name: a.name || a.context.split("/").pop(),
                })),
              }),
            };
            break;
          case this.QuestionType.DownloadFile:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: (() => {
                let list = [];
                try {
                  const parsed = JSON.parse(item.chooseList || "{}");
                  list = (parsed.list || []).map((temp) => ({
                    id: temp.id || "",
                    text: temp.text || "",
                    fileName: temp.fileName || "",
                  }));
                } catch (e) {
                  console.warn("chooseList parse error", e);
                }
                return JSON.stringify({ list });
              })(),
              list: (() => {
                try {
                  const parsed = JSON.parse(item.chooseList || "{}");
                  return (parsed.list || []).map((temp) => ({
                    id: temp.id || "",
                    text: temp.text || "",
                    fileName: temp.fileName || "",
                  }));
                } catch (e) {
                  return [];
                }
              })(),
            };
            break;
          case this.QuestionType.CASCADER:
            const parsedChooseList = (() => {
              try {
                return JSON.parse(item.chooseList) || {};
              } catch (e) {
                return { options: [] };
              }
            })();

            const processOptions = (options) => {
              return options.map((opt) => ({
                ...opt,
                children: opt.children
                  ? processOptions(opt.children)
                  : undefined,
              }));
            };

            const answerArr = answerItem.answer || [];
            const userAnswer = answerArr
              .map((a) => a.context)
              .filter(Boolean)
              .join(" / ");
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                options: processOptions(parsedChooseList.options || []),
                value: userAnswer,
              }),
            };
            break;
          case this.QuestionType.BDQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.IDQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.ELQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                  };
                }),
                value:
                  answerItem.answer.length > 0
                    ? answerItem.answer[0].context
                    : "",
              }),
            };
            break;
          case this.QuestionType.WX:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.MatrixSCQ:
            // this.dataList[i] = item
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    oneId: answerItem.answer[idx].oneId || "",
                    twoId: answerItem.answer[idx].twoId || "",
                    threeId: answerItem.answer[idx].threeId || "",
                  };
                }),
                verticalNum: JSON.parse(item.chooseList).verticalNum,
                horizontalTitle: JSON.parse(item.chooseList).horizontalTitle,
                percentageTitle: JSON.parse(item.chooseList).percentageTitle,
              }),
            };
            break;
          case this.QuestionType.MatrixMCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    oneId: answerItem.answer[idx].oneId || "",
                    twoId: answerItem.answer[idx].twoId || "",
                    threeId: answerItem.answer[idx].threeId || "",
                  };
                }),
                verticalNum: JSON.parse(item.chooseList).verticalNum,
                horizontalTitle: JSON.parse(item.chooseList).horizontalTitle,
                percentageTitle: JSON.parse(item.chooseList).percentageTitle,
              }),
            };
            break;
          case this.QuestionType.ImageSCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    isChoose:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                        : false,
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.ImageMCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    isChoose: answerItem.answer.some((a) => {
                      return temp.id === a.id;
                    }),
                  };
                }),
                minCount: JSON.parse(item.chooseList).minCount,
                maxCount: JSON.parse(item.chooseList).maxCount,
                isCountMust: JSON.parse(item.chooseList).isCountMust,
                isCountSwitch: JSON.parse(item.chooseList).isCountSwitch,
              }),
            };
            break;
          case this.QuestionType.ImageOrVideo:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.TITLE:
            // 标题
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
            };
            break;
          case this.QuestionType.PageBreak:
            this.dataList[i] = {
              ...item,
              if_hide: 0,
            };
            break;
          case this.QuestionType.Signature:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              signatureImage:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          default:
            break;
        }
      }

      console.log("答案答案答案答案：", this.answers);
      console.log("数据数据数据数据：", this.dataList);
    },
    answerExamDisplay(array, answers) {
      console.log("这个是问题列表：", array);
      console.log("这个是后台返回的答案：", answers);
      this.answers = [];
      // 初始化answers,构建出每道题目的答案数据
      for (let i = 0; i < array.length; i++) {
        if (answers[i] !== null && answers[i] !== undefined) {
          this.answers.push(answers[i]);
        } else {
          if (array[i].type === this.QuestionType.SBQ) {
            const num = array[i].caseProblem.split("____").length - 1;
            // 构建答案数据
            let answer = [];
            for (let j = 0; j < num; j++) {
              answer.push({
                id: "",
                context: "",
              });
            }
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: answer,
            });
          } else if (array[i].type === this.QuestionType.IMAGE) {
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: [],
            });
          } else if (array[i].type === this.QuestionType.ClozeTest) {
            console.log(
              JSON.parse(array[i].chooseList).list.length,
              "qdwqdqwdqwe11231231231231",
            );
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: Array.from(
                { length: JSON.parse(array[i].chooseList).list.length },
                (_, index) => ({
                  id: "",
                  context: "",
                }),
              ),
            });
          } else {
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: [],
            });
          }
        }
      }
      console.log("这个是构建的数据答案：", this.answers);
      // 遍历每道题目的答案数据,把答案数据渲染到this.list里面
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const answerItem =
          this.answers.find(
            (a) => parseInt(a.question_id) === parseInt(item.id),
          ) === undefined
            ? {
                question_id: item.id,
                type: array[i].type,
                if_hide: 0,
                answer: [],
              }
            : this.answers.find(
                (a) => parseInt(a.question_id) === parseInt(item.id),
              );
        switch (item.type) {
          case this.QuestionType.SCQ:
            console.log("这个是SCQ", item, answerItem);
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              ifRight: answerItem.ifRight,
              score: answerItem.score,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    color:
                      this.answerRecordId === null
                        ? "0"
                        : answerItem.answer.length > 0
                        ? answerItem.answer[idx] && answerItem.answer[idx].color
                          ? answerItem.answer[idx].color
                          : "0"
                        : "0",
                    isChoose: answerItem.answer.some((a) => {
                      return temp.id === a.id;
                    }),
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? answerItem.answer[0].context
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.MCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              ifRight: answerItem.ifRight,
              score: answerItem.score,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    color:
                      this.answerRecordId === null
                        ? "0"
                        : answerItem.answer.length > 0
                        ? answerItem.answer[idx] && answerItem.answer[idx].color
                          ? answerItem.answer[idx].color
                          : "0"
                        : "0",
                    isChoose: answerItem.answer.some((a) => {
                      return temp.id === a.id;
                    }),
                    fill_prompt: answerItem.answer
                      .filter((b) => {
                        return temp.id === b.id;
                      })
                      .map((c) => {
                        return c.context;
                      }),
                  };
                }),
                minCount: JSON.parse(item.chooseList).minCount,
                maxCount: JSON.parse(item.chooseList).maxCount,
              }),
            };
            break;
          case this.QuestionType.SBQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              ifRight: answerItem.ifRight,
              score: answerItem.score,
              answer: answerItem.answer.map((temp) => {
                return {
                  id: temp.id,
                  context: temp.context,
                  color: temp.color,
                };
              }),
            };
            break;
          case this.QuestionType.REMARK:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              ifRight: answerItem.ifRight,
              score: answerItem.score,
            };
            break;
          case this.QuestionType.MBQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              ifRight: answerItem.ifRight,
              score: answerItem.score,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    color:
                      this.answerRecordId === null
                        ? "0"
                        : answerItem.answer.length > 0
                        ? answerItem.answer[idx].color
                        : "0",
                    context:
                      answerItem.answer.length > 0
                        ? answerItem.answer[idx].context
                        : "",
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.QA:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              ifRight: answerItem.ifRight,
              score: answerItem.score,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.TFQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              ifRight: answerItem.ifRight,
              score: answerItem.score,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    color:
                      this.answerRecordId === null
                        ? "0"
                        : answerItem.answer.length > 0
                        ? answerItem.answer[idx] && answerItem.answer[idx].color
                          ? answerItem.answer[idx].color
                          : "0"
                        : "0",
                    isChoose: answerItem.answer.some((a) => {
                      return temp.id === a.id;
                    }),
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? answerItem.answer[0].context
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.IMAGE:
            this.dataList[i] = {
              ...item,
              if_hide: this.answers[i].if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: answerItem.answer.length > 0 ? answerItem.answer : [],
              }),
            };
            break;
          case this.QuestionType.ClozeTest:
            console.log(
              "3u8yr93t23892398ty239t238ty32t23",
              answerItem.answer,
              item,
            );

            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              ifRight: answerItem.ifRight,
              score: answerItem.score,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  console.log(
                    "lrpgktophhkglrew",
                    temp.title,
                    answerItem.answer[idx],
                  );
                  const title = temp.title.map((tit, k) => {
                    return {
                      ...tit,
                      color:
                        this.answerRecordId === null
                          ? "0"
                          : answerItem.answer.length > 0
                          ? answerItem.answer[idx] &&
                            answerItem.answer[idx].title
                            ? answerItem.answer[idx].title[k].color
                            : "0"
                          : "0",
                      isChoose: tit.id === answerItem.answer[idx].context,
                    };
                  });
                  return {
                    ...temp,
                    title: title,
                    //   color: this.answerRecordId === null ? '0' : (this.answers[i].answer.length > 0? this.answers[i].answer[idx].color : '0'),
                    //   context: this.answers[i].answer.length > 0 ? this.answers[i].answer[idx].context : '',
                    // isChoose: this.answers[i].answer.length > 0 ? this.answers[i].answer[0].id === temp.id : false,
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.NAME:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.GENDER:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                    // isChoose: answerItem.answer.length > 0 ? parseInt(answerItem.answer[0].id) === parseInt(temp.id) : false,
                    isChoose: answerItem.answer.some((a) => {
                      return temp.id === a.id;
                    }),
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? answerItem.answer[0].context
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.AGE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                    // isChoose: answerItem.answer.length > 0 ? parseInt(answerItem.answer[0].id) === parseInt(temp.id) : false,
                    isChoose: answerItem.answer.some((a) => {
                      return temp.id === a.id;
                    }),
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? answerItem.answer[0].context
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.TEL:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.EMAIL:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.DATE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.TIME:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.ADDR:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.BDQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.IDQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.ELQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                  };
                }),
                value:
                  answerItem.answer.length > 0
                    ? answerItem.answer[0].context
                    : "",
              }),
            };
            break;
          case this.QuestionType.WX:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.Customize:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          default:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
            };
            break;
        }
      }
      this.answerRecord = JSON.stringify(this.answers);

      console.log("答案答案答案答案1：", this.answers);
      console.log("数据数据数据数据1：", this.dataList);
    },
    answerEvaluationDisplay(array, answers) {
      console.log("这个是问题列表：", array);
      console.log("这个是后台返回的答案：", answers);
      this.answers = [];
      // 初始化answers,构建出每道题目的答案数据
      for (let i = 0; i < array.length; i++) {
        if (answers[i] !== null && answers[i] !== undefined) {
          answers[i].if_hide = 0;
          this.answers.push(answers[i]);
        } else if (array[i].type === this.QuestionType.EvaluationMatrixSCQ) {
          this.answers.push({
            question_id: array[i].id,
            type: array[i].type,
            if_hide: 0,
            answer: JSON.parse(array[i].chooseList).list.map((item) => {
              return {
                id: item.id,
                oneId: "",
                twoId: "",
                threeId: "",
              };
            }),
          });
        } else {
          this.answers.push({
            question_id: array[i].id,
            type: array[i].type,
            if_hide: 0,
            answer: [],
          });
        }
      }
      console.log("这个是构建的数据答案：", this.answers);
      // 遍历每道题目的答案数据,把答案数据渲染到this.list里面
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const answerItem =
          this.answers.find(
            (a) => parseInt(a.question_id) === parseInt(item.id),
          ) === undefined
            ? {
                question_id: item.id,
                type: array[i].type,
                if_hide: 0,
                answer: [],
              }
            : this.answers.find(
                (a) => parseInt(a.question_id) === parseInt(item.id),
              );
        console.log("这是answer", answerItem, i);
        switch (item.type) {
          case this.QuestionType.EvaluationSCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    isChoose:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                        : false,
                    placeholder: temp.fill_prompt,
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                          ? answerItem.answer[0].context
                          : ""
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.EvaluationMCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  const matched = answerItem.answer.find(
                    (a) => parseInt(a.id) === parseInt(temp.id),
                  );
                  return {
                    ...temp,
                    placeholder: temp.fill_prompt,
                    isChoose: !!matched,
                    fill_prompt:
                      matched && matched.context ? matched.context : "",
                  };
                }),
                minCount: JSON.parse(item.chooseList).minCount,
                maxCount: JSON.parse(item.chooseList).maxCount,
                isCountMust: JSON.parse(item.chooseList).isCountMust,
                isCountSwitch: JSON.parse(item.chooseList).isCountSwitch,
              }),
            };
            break;
          case this.QuestionType.EvaluationNPS:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? parseInt(answerItem.answer[0].context)
                  : -1,
            };
            break;
          case this.QuestionType.EvaluationScore:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, index) => {
                  return {
                    ...temp,
                    context:
                      answerItem.answer.length > 0
                        ? answerItem.answer[index].context
                        : 0,
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.TextDescription:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.NAME:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.GENDER:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                    isChoose:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                        : false,
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? answerItem.answer[0].context
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.AGE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                    isChoose:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                        : false,
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? answerItem.answer[0].context
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.DATE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.ADDR:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.Industry:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.Occupation:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.EvaluationWRQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  const matchedAnswer = (answerItem.answer || []).find(
                    (ans) => ans.id === temp.id,
                  );
                  return {
                    ...temp,
                    value: matchedAnswer ? matchedAnswer.context : "",
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.ELQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                  };
                }),
                value:
                  answerItem.answer.length > 0
                    ? answerItem.answer[0].context
                    : "",
              }),
            };
            break;
          case this.QuestionType.Customize:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.EvaluationMatrixSCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide ? answerItem.if_hide : 0,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    oneId: answerItem.answer[idx].oneId || "",
                    twoId: answerItem.answer[idx].twoId || "",
                    threeId: answerItem.answer[idx].threeId || "",
                  };
                }),
                verticalNum: JSON.parse(item.chooseList).verticalNum,
                horizontalTitle: JSON.parse(item.chooseList).horizontalTitle,
                percentageTitle: JSON.parse(item.chooseList).percentageTitle,
              }),
            };
            break;
          case this.QuestionType.ImageOrVideo:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide ? answerItem.if_hide : 0,
              status: this.status,
            };
            break;
          case this.QuestionType.Audio:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide ? answerItem.if_hide : 0,
              status: this.status,
            };
            break;
          default:
            break;
        }
      }

      console.log("答案答案答案答案2：", this.answers);
      console.log("数据数据数据数据2：", this.dataList);
    },
  },
};
</script>

<style scoped>
.defaultBox {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.defaultBox .left {
  position: relative;
  padding: 0 20px;
  width: 320px;
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.defaultBox .left .title {
  padding: 20px 0;
  font-size: 18px;
  font-weight: bold;
  color: #1e80ff;
  text-align: center;
  border-bottom: 1px solid rgba(241, 243, 247, 1);
}

.defaultBox .left .profilePhoto {
  margin-top: 30px;
  margin-bottom: 20px;
}

.defaultBox .left .profilePhoto img {
  width: 90px;
  height: 90px;
  border-radius: 90px;
}

.defaultBox .left .item {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.defaultBox .left .item:last-child {
  margin-bottom: 80px;
}

.defaultBox .left .item .text {
  width: calc(100% - 120px);
  text-align: center;
  word-break: break-all;
}

.defaultBox .right {
  display: flex;
  flex-direction: column;
  width: 790px;
  border-radius: 5px;
  height: calc(100vh - 80px);
  overflow-y: auto;
  gap: 10px;
}

.defaultBox .right::-webkit-scrollbar {
  width: 8px;
}

.defaultBox .right::-webkit-scrollbar-track {
  background: none;
}

.defaultBox .right::-webkit-scrollbar-thumb {
  background: #8b8b8b;
  border-radius: 4px;
}

.defaultBox .right .item {
  position: relative;
}

.defaultBox .right .item::after {
  display: block;
  content: "";
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  position: absolute;
  top: 0;
  left: 0;
}

.defaultBox .right .item.max-diff::after {
  height: 80%;
}
</style>



// WEBPACK FOOTER //
// src/views/DataStatisticsPage/DialogDetail/index.vue